// 多公司 文案配置
let companyConfigStr = {};
switch (process.env.COMPANY_NAME) {
  case "fenghuo": //峰火科技有限公司文案
    companyConfigStr = {
      companyName: "臻效VIP", //
      companyAllName: "杭州峰火科技有限公司", //公司全称
      englishName: "Hangzhou Fenghuo Technology Co., Ltd.", //英文名称
      copyRight: "浙ICP备20010811号", //备案号
      logo_1: "/static/images/logo_01_1.png", //登录页logo
      seagoorName: "峰火", //公司简称
      email: "cs@zhenxiaovip.com", //邮件
      qiyukefu_url:
        "https://qiyukf.com/script/bf62e25c3dfcd0a254850c394f751260.js", //七鱼客服链接
      comp_url: "zhenxiaovip", //域名
      kefu_name_1: "", //客服1名称
      kefu_name_2: "小臻", //客服2名称
      kefu_wechat_1: "", //客服1微信
      kefu_wechat_2: "wxid_nxrc4oxvcxrl22", //客服2微信
      kefu_tel: "400-114-1185", //400电话
      skeleton_bg800: "bg800-1.png", //骨架屏占位图
      skeleton_bg800_1: "/static/images/bg800_1-1.png", //骨架屏占位图
      skeleton_bg1200: "/static/images/bg1200-1.png", //骨架屏占位图
      mall_Img: "https://item.qn.zhenxiaovip.com/fuli20200103.jpg", //mall占位图
      preview_product_header: "/static/images/preview_product_header-1.png", //预览头部图
      preview_product_footer: "/static/images/preview_product_footer-1.png", //预览底部图
      /***
       **
       * 右侧导航栏
       **
       ***/
      right_sildbar_xiaochengxu:
        "/static/images/right_sidebar/xiaochengxu-1.png", //右侧导航栏 小程序 默认
      right_sildbar_xiaochengxu_choose:
        "/static/images/right_sidebar/xiaochengxu_choose-1.png", //右侧导航栏 小程序 选中
      right_sildbar_coupon: "/static/images/right_sidebar/coupon-1.png", //右侧导航栏 优惠券 默认
      right_sildbar_coupon_choose:
        "/static/images/right_sidebar/coupon_choose-1.png", //右侧导航栏 优惠券 选中
      right_sildbar_shop_car: "/static/images/right_sidebar/shop_car-1.png", //右侧导航栏 购物车 默认
      right_sildbar_shop_car_choose:
        "/static/images/right_sidebar/shop_car_choose-1.png", //右侧导航栏 购物车 选中
      right_sildbar_point: "/static/images/right_sidebar/point-1.png", //右侧导航栏 积分 默认
      right_sildbar_point_choose:
        "/static/images/right_sidebar/point_choose-1.png", //右侧导航栏 积分 选中
      right_sildbar_order: "/static/images/right_sidebar/order-1.png", //右侧导航栏 订单 默认
      right_sildbar_order_choose:
        "/static/images/right_sidebar/order_choose-1.png", //右侧导航栏 订单 选中
      right_sildbar_service: "/static/images/right_sidebar/service-1.png", //右侧导航栏 客服 默认
      right_sildbar_service_choose:
        "/static/images/right_sidebar/service_choose-1.png", //右侧导航栏 客服 选中
      right_sildbar_gongzhonghao:
        "/static/images/right_sidebar/gongzhonghao-1.png", //右侧导航栏 公众号 默认
      right_sildbar_gongzhonghao_choose:
        "/static/images/right_sidebar/gongzhonghao_choose-1.png", //右侧导航栏 公众号 选中
      right_sildbar_up: "/static/images/right_sidebar/up-1.png", //右侧导航栏 回到顶部 默认
      right_sildbar_up_choose: "/static/images/right_sidebar/up_choose-1.png" //右侧导航栏 回到顶部 选中
    };
    break;
  case "minsheng": //默认 民生置业
    companyConfigStr = {
      companyName: "民生置业", //
      companyAllName: "杭州福粒科技有限公司", //公司全称
      englishName: "Hangzhou Fuli Technology Co., Ltd.", //英文名称
      copyRight: "浙ICP备17011239号-1", //备案号
      logo_1: "/static/images/logo_01-2.png", //登录页logo
      seagoorName: "民生置业", //公司简称
      email: "cs@seagoor.com", //邮件
      kefuImg: "https://supplier.qn.seagoor.com/wechat_qiyuzixun.png", //客服二维码
      qiyukefu_url:
        "https://qiyukf.com/script/6e39dddabff63d902f55df3961c2793d.js", //七鱼客服链接
      comp_url: "lixiangshop", //域名
      kefu_name_1: "小福", //客服1名称
      kefu_name_2: "小粒", //客服2名称
      kefu_wechat_1: "fuli3606", //客服1微信
      kefu_wechat_2: "fuli7151", //客服2微信
      kefu_tel: "400-826-4949", //400电话
      skeleton_bg800: "bg800-2.png", //骨架屏占位图
      skeleton_bg800_1: "/static/images/bg800-2.png", //骨架屏占位图
      skeleton_bg1200: "/static/images/bg1200.png", //骨架屏占位图
      mall_Img: "https://supplier.qn.seagoor.com/fuli20200103.jpeg", //mall占位图
      preview_product_header: "/static/images/preview_product_header.png", //预览头部图
      preview_product_footer: "/static/images/preview_product_footer.png", //预览底部图
      /***
       **
       * 右侧导航栏
       **
       ***/
      right_sildbar_xiaochengxu: "/static/images/right_sidebar/xiaochengxu.png", //右侧导航栏 小程序 默认
      right_sildbar_xiaochengxu_choose:
        "/static/images/right_sidebar/xiaochengxu_choose.png", //右侧导航栏 小程序 选中
      right_sildbar_coupon: "/static/images/right_sidebar/coupon.png", //右侧导航栏 优惠券 默认
      right_sildbar_coupon_choose:
        "/static/images/right_sidebar/coupon_choose.png", //右侧导航栏 优惠券 选中
      right_sildbar_shop_car: "/static/images/right_sidebar/shop_car.png", //右侧导航栏 购物车 默认
      right_sildbar_shop_car_choose:
        "/static/images/right_sidebar/shop_car_choose.png", //右侧导航栏 购物车 选中
      right_sildbar_point: "/static/images/right_sidebar/point.png", //右侧导航栏 积分 默认
      right_sildbar_point_choose:
        "/static/images/right_sidebar/point_choose.png", //右侧导航栏 积分 选中
      right_sildbar_order: "/static/images/right_sidebar/order.png", //右侧导航栏 订单 默认
      right_sildbar_order_choose:
        "/static/images/right_sidebar/order_choose.png", //右侧导航栏 订单 选中
      right_sildbar_service: "/static/images/right_sidebar/service.png", //右侧导航栏 客服 默认
      right_sildbar_service_choose:
        "/static/images/right_sidebar/service_choose.png", //右侧导航栏 客服 选中
      right_sildbar_gongzhonghao:
        "/static/images/right_sidebar/gongzhonghao.png", //右侧导航栏 公众号 默认
      right_sildbar_gongzhonghao_choose:
        "/static/images/right_sidebar/gongzhonghao_choose.png", //右侧导航栏 公众号 选中
      right_sildbar_up: "/static/images/right_sidebar/up.png", //右侧导航栏 回到顶部 默认
      right_sildbar_up_choose: "/static/images/right_sidebar/up_choose.png" //右侧导航栏 回到顶部 选中
    };
    break;
  case "mz": //默认 民置商城
    companyConfigStr = {
      companyName: "民置", //
      companyAllName: "杭州民置福粒科技有限公司", //公司全称
      englishName: "Hangzhou Minzhifuli Technology Co., Ltd.", //英文名称
      copyRight: "浙ICP备20024592号-1", //备案号
      logo_1: "/static/images/logo_01_mz.png", //登录页logo
      seagoorName: "民置", //公司简称
      email: "cs@minzhishangcheng.com", //邮件
      kefuImg: "https://item.qn.minzhishangcheng.com/qiyukefu_mz.png", //客服二维码
      // bottomLogo: '../images/33_mz.png', //底部logo
      qiyukefu_url:
        "https://qiyukf.com/script/4d2fa55660c083fe837512fdc172f528.js", //七鱼客服链接
      comp_url: "minzhishangcheng", //域名
      kefu_name_1: "", //客服1名称
      kefu_name_2: "小置", //客服2名称
      kefu_wechat_1: "", //客服1微信
      kefu_wechat_2: "minzhi3800", //客服2微信
      kefu_tel: "400-826-4646", //400电话
      skeleton_bg800: "bg800_mz.png", //骨架屏占位图
      skeleton_bg800_1: "/static/images/bg800_mz.png", //骨架屏占位图
      skeleton_bg1200: "/static/images/bg1200_mz.png", //骨架屏占位图
      mall_Img: "https://supplier.qn.seagoor.com/fuli20200103.jpeg", //mall占位图
      preview_product_header: "/static/images/preview_product_header_mz.png", //预览头部图
      preview_product_footer: "/static/images/preview_product_footer_mz.png", //预览底部图
      /***
       **
       * 右侧导航栏
       **
       ***/
      right_sildbar_xiaochengxu: "/static/images/right_sidebar/xiaochengxu.png", //右侧导航栏 小程序 默认
      right_sildbar_xiaochengxu_choose:
        "/static/images/right_sidebar/xiaochengxu_choose.png", //右侧导航栏 小程序 选中
      right_sildbar_coupon: "/static/images/right_sidebar/coupon.png", //右侧导航栏 优惠券 默认
      right_sildbar_coupon_choose:
        "/static/images/right_sidebar/coupon_choose.png", //右侧导航栏 优惠券 选中
      right_sildbar_shop_car: "/static/images/right_sidebar/shop_car.png", //右侧导航栏 购物车 默认
      right_sildbar_shop_car_choose:
        "/static/images/right_sidebar/shop_car_choose.png", //右侧导航栏 购物车 选中
      right_sildbar_point: "/static/images/right_sidebar/point.png", //右侧导航栏 积分 默认
      right_sildbar_point_choose:
        "/static/images/right_sidebar/point_choose.png", //右侧导航栏 积分 选中
      right_sildbar_order: "/static/images/right_sidebar/order.png", //右侧导航栏 订单 默认
      right_sildbar_order_choose:
        "/static/images/right_sidebar/order_choose.png", //右侧导航栏 订单 选中
      right_sildbar_service: "/static/images/right_sidebar/service.png", //右侧导航栏 客服 默认
      right_sildbar_service_choose:
        "/static/images/right_sidebar/service_choose.png", //右侧导航栏 客服 选中
      right_sildbar_gongzhonghao:
        "/static/images/right_sidebar/gongzhonghao.png", //右侧导航栏 公众号 默认
      right_sildbar_gongzhonghao_choose:
        "/static/images/right_sidebar/gongzhonghao_choose.png", //右侧导航栏 公众号 选中
      right_sildbar_up: "/static/images/right_sidebar/up.png", //右侧导航栏 回到顶部 默认
      right_sildbar_up_choose: "/static/images/right_sidebar/up_choose.png" //右侧导航栏 回到顶部 选中
    };
    break;
  case "jn": //默认 跨通
    companyConfigStr = {
      companyName: "跨通", //
      companyAllName: "四川跨通国际商贸有限公司", //公司全称
      englishName: "Sichuan Kuatong Technology Co., Ltd.", //英文名称
      copyRight: "蜀ICP备2020026363号", //备案号
      logo_1: '/static/images/logo_01_kt.png', //登录页logo
      seagoorName: "跨通国际", //公司简称
      email: "member@kuatongjicai.com", //邮件
      qiyukefu_url:
        "https://qiyukf.com/script/6e39dddabff63d902f55df3961c2793d.js", //七鱼客服链接
      comp_url: "kuatongjicai", //域名
      kefu_name_1: "小福", //客服1名称
      kefu_name_2: "小粒", //客服2名称
      kefu_wechat_1: "fuli3606", //客服1微信
      kefu_wechat_2: "fuli7151", //客服2微信
      kefu_tel: "400-826-4949", //400电话
      skeleton_bg800: "bg800_kt.png", //骨架屏占位图
      skeleton_bg800_1: "/static/images/bg800_kt.png", //骨架屏占位图
      skeleton_bg1200: "/static/images/bg1200_kt.png", //骨架屏占位图
      mall_Img: "https://supplier.qn.seagoor.com/fuli20200103.jpeg", //mall占位图
      preview_product_header: "/static/images/preview_product_header_kt.png", //预览头部图
      preview_product_footer: "/static/images/preview_product_footer_kt.png", //预览底部图
      /***
       **
       * 右侧导航栏
       **
       ***/
      right_sildbar_xiaochengxu: "/static/images/right_sidebar/xiaochengxu.png", //右侧导航栏 小程序 默认
      right_sildbar_xiaochengxu_choose:
        "/static/images/right_sidebar/xiaochengxu_choose.png", //右侧导航栏 小程序 选中
      right_sildbar_coupon: "/static/images/right_sidebar/coupon.png", //右侧导航栏 优惠券 默认
      right_sildbar_coupon_choose:
        "/static/images/right_sidebar/coupon_choose.png", //右侧导航栏 优惠券 选中
      right_sildbar_shop_car: "/static/images/right_sidebar/shop_car.png", //右侧导航栏 购物车 默认
      right_sildbar_shop_car_choose:
        "/static/images/right_sidebar/shop_car_choose.png", //右侧导航栏 购物车 选中
      right_sildbar_point: "/static/images/right_sidebar/point.png", //右侧导航栏 积分 默认
      right_sildbar_point_choose:
        "/static/images/right_sidebar/point_choose.png", //右侧导航栏 积分 选中
      right_sildbar_order: "/static/images/right_sidebar/order.png", //右侧导航栏 订单 默认
      right_sildbar_order_choose:
        "/static/images/right_sidebar/order_choose.png", //右侧导航栏 订单 选中
      right_sildbar_service: "/static/images/right_sidebar/service.png", //右侧导航栏 客服 默认
      right_sildbar_service_choose:
        "/static/images/right_sidebar/service_choose.png", //右侧导航栏 客服 选中
      right_sildbar_gongzhonghao:
        "/static/images/right_sidebar/gongzhonghao.png", //右侧导航栏 公众号 默认
      right_sildbar_gongzhonghao_choose:
        "/static/images/right_sidebar/gongzhonghao_choose.png", //右侧导航栏 公众号 选中
      right_sildbar_up: "/static/images/right_sidebar/up.png", //右侧导航栏 回到顶部 默认
      right_sildbar_up_choose: "/static/images/right_sidebar/up_choose.png" //右侧导航栏 回到顶部 选中
    };
    break;
  case "lyt": //默认 朗佑堂
    companyConfigStr = {
      companyName: "朗佑堂", //
      companyAllName: "贵州朗佑堂制药有限公司", //公司全称
      englishName: "Langyoutang Technology Co., Ltd.", //英文名称
      copyRight: "黔ICP备20001949号-1", //备案号
      logo_1: '/static/images/logo_01_lyt.png', //登录页logo
      seagoorName: "朗佑堂", //公司简称
      email: "lyt_system@lykg.cn", //邮件
      qiyukefu_url:
        "https://qiyukf.com/script/a8f12cd6009bf418985789094cf5da65.js", //七鱼客服链接
      comp_url: "lyt666", //域名
      kefu_name_1: "小冰", //客服1名称
      kefu_name_2: "小冰", //客服2名称
      kefu_wechat_1: "wxid_4wbqlkr9umvm22", //客服1微信
      kefu_wechat_2: "wxid_4wbqlkr9umvm22", //客服2微信
      kefu_tel: "400-969-0969", //400电话
      skeleton_bg800: "bg800_lyt.png", //骨架屏占位图
      skeleton_bg800_1: "/static/images/bg800_lyt.png", //骨架屏占位图
      skeleton_bg1200: "/static/images/bg1200_lyt.png", //骨架屏占位图
      mall_Img: "https://supplier.qn.seagoor.com/fuli20200103.jpeg", //mall占位图
      preview_product_header: "/static/images/preview_product_header_lyt.png", //预览头部图
      preview_product_footer: "/static/images/preview_product_footer_lyt.png", //预览底部图
      /***
       **
       * 右侧导航栏
       **
       ***/
      right_sildbar_xiaochengxu: "/static/images/right_sidebar/xiaochengxu.png", //右侧导航栏 小程序 默认
      right_sildbar_xiaochengxu_choose:
        "/static/images/right_sidebar/xiaochengxu_choose.png", //右侧导航栏 小程序 选中
      right_sildbar_coupon: "/static/images/right_sidebar/coupon.png", //右侧导航栏 优惠券 默认
      right_sildbar_coupon_choose:
        "/static/images/right_sidebar/coupon_choose.png", //右侧导航栏 优惠券 选中
      right_sildbar_shop_car: "/static/images/right_sidebar/shop_car.png", //右侧导航栏 购物车 默认
      right_sildbar_shop_car_choose:
        "/static/images/right_sidebar/shop_car_choose.png", //右侧导航栏 购物车 选中
      right_sildbar_point: "/static/images/right_sidebar/point.png", //右侧导航栏 积分 默认
      right_sildbar_point_choose:
        "/static/images/right_sidebar/point_choose.png", //右侧导航栏 积分 选中
      right_sildbar_order: "/static/images/right_sidebar/order.png", //右侧导航栏 订单 默认
      right_sildbar_order_choose:
        "/static/images/right_sidebar/order_choose.png", //右侧导航栏 订单 选中
      right_sildbar_service: "/static/images/right_sidebar/service.png", //右侧导航栏 客服 默认
      right_sildbar_service_choose:
        "/static/images/right_sidebar/service_choose.png", //右侧导航栏 客服 选中
      right_sildbar_gongzhonghao:
        "/static/images/right_sidebar/gongzhonghao.png", //右侧导航栏 公众号 默认
      right_sildbar_gongzhonghao_choose:
        "/static/images/right_sidebar/gongzhonghao_choose.png", //右侧导航栏 公众号 选中
      right_sildbar_up: "/static/images/right_sidebar/up.png", //右侧导航栏 回到顶部 默认
      right_sildbar_up_choose: "/static/images/right_sidebar/up_choose.png" //右侧导航栏 回到顶部 选中
    };
    break;
    case "de": //默认 东阿数智城市有限公司文案
    companyConfigStr = {
      companyName: "东阿数智城市", //
      companyAllName: "东阿数智城市运营有限公司", //公司全称
      englishName: "Donge Shuzhi City Technology Co., Ltd.", //英文名称
      copyRight: "鲁ICP备2020046222号-1", //备案号
      logo_1: '/static/images/logo_01_de.png', //登录页logo
      seagoorName: "东阿数智城市", //公司简称
      email: "vip@deszcs.com", //邮件
      qiyukefu_url:
        "https://qiyukf.com/script/9670be00c68d838255220bdbc3e99502.js", //七鱼客服链接
      comp_url: "deszcs", //域名
      kefu_name_1: "小智", //客服1名称
      kefu_name_2: "小智", //客服2名称
      kefu_wechat_1: "18265539185", //客服1微信
      kefu_wechat_2: "18265539185", //客服2微信
      kefu_tel: "400-969-0969", //400电话
      skeleton_bg800: "bg800_de.png", //骨架屏占位图
      skeleton_bg800_1: "/static/images/bg800_de.png", //骨架屏占位图
      skeleton_bg1200: "/static/images/bg1200_de.png", //骨架屏占位图
      mall_Img: "https://supplier.qn.seagoor.com/fuli20200103.jpeg", //mall占位图
      preview_product_header: "/static/images/preview_product_header_de.png", //预览头部图
      preview_product_footer: "/static/images/preview_product_footer_de.png", //预览底部图
      /***
       **
       * 右侧导航栏
       **
       ***/
      right_sildbar_xiaochengxu: "/static/images/right_sidebar/xiaochengxu.png", //右侧导航栏 小程序 默认
      right_sildbar_xiaochengxu_choose:
        "/static/images/right_sidebar/xiaochengxu_choose.png", //右侧导航栏 小程序 选中
      right_sildbar_coupon: "/static/images/right_sidebar/coupon.png", //右侧导航栏 优惠券 默认
      right_sildbar_coupon_choose:
        "/static/images/right_sidebar/coupon_choose.png", //右侧导航栏 优惠券 选中
      right_sildbar_shop_car: "/static/images/right_sidebar/shop_car.png", //右侧导航栏 购物车 默认
      right_sildbar_shop_car_choose:
        "/static/images/right_sidebar/shop_car_choose.png", //右侧导航栏 购物车 选中
      right_sildbar_point: "/static/images/right_sidebar/point.png", //右侧导航栏 积分 默认
      right_sildbar_point_choose:
        "/static/images/right_sidebar/point_choose.png", //右侧导航栏 积分 选中
      right_sildbar_order: "/static/images/right_sidebar/order.png", //右侧导航栏 订单 默认
      right_sildbar_order_choose:
        "/static/images/right_sidebar/order_choose.png", //右侧导航栏 订单 选中
      right_sildbar_service: "/static/images/right_sidebar/service.png", //右侧导航栏 客服 默认
      right_sildbar_service_choose:
        "/static/images/right_sidebar/service_choose.png", //右侧导航栏 客服 选中
      right_sildbar_gongzhonghao:
        "/static/images/right_sidebar/gongzhonghao.png", //右侧导航栏 公众号 默认
      right_sildbar_gongzhonghao_choose:
        "/static/images/right_sidebar/gongzhonghao_choose.png", //右侧导航栏 公众号 选中
      right_sildbar_up: "/static/images/right_sidebar/up.png", //右侧导航栏 回到顶部 默认
      right_sildbar_up_choose: "/static/images/right_sidebar/up_choose.png" //右侧导航栏 回到顶部 选中
    };
    break;
    case "dongdong": //默认 咚咚聚合有限公司文案
    companyConfigStr = {
      companyName: "咚咚聚合", //
      companyAllName: "杭州咚咚聚合科技有限公司", //公司全称
      englishName: "Dongdong Group Technology Co., Ltd.", //英文名称
      copyRight: "浙ICP备2020042400号-1", //备案号
      logo_1: '/static/images/logo_01_dd.png', //登录页logo
      seagoorName: "咚咚聚合", //公司简称
      email: "vip@dongdonggroup.com", //邮件
      qiyukefu_url:
        "https://qiyukf.com/script/c3d01d20c5b4c61be11b596b2e317a38.js", //七鱼客服链接
      comp_url: "dongdonggroup", //域名
      kefu_name_1: "小福", //客服1名称
      kefu_name_2: "小粒", //客服2名称
      kefu_wechat_1: "fuli3606", //客服1微信
      kefu_wechat_2: "fuli7151", //客服2微信
      kefu_tel: "400-969-0969", //400电话
      skeleton_bg800: "bg800_dd.png", //骨架屏占位图
      skeleton_bg800_1: "/static/images/bg800_dd.png", //骨架屏占位图
      skeleton_bg1200: "/static/images/bg1200_dd.png", //骨架屏占位图
      mall_Img: "https://supplier.qn.seagoor.com/fuli20200103.jpeg", //mall占位图
      preview_product_header: "/static/images/preview_product_header_dd.png", //预览头部图
      preview_product_footer: "/static/images/preview_product_footer_dd.png", //预览底部图
      /***
       **
       * 右侧导航栏
       **
       ***/
      right_sildbar_xiaochengxu: "/static/images/right_sidebar/xiaochengxu.png", //右侧导航栏 小程序 默认
      right_sildbar_xiaochengxu_choose:
        "/static/images/right_sidebar/xiaochengxu_choose.png", //右侧导航栏 小程序 选中
      right_sildbar_coupon: "/static/images/right_sidebar/coupon.png", //右侧导航栏 优惠券 默认
      right_sildbar_coupon_choose:
        "/static/images/right_sidebar/coupon_choose.png", //右侧导航栏 优惠券 选中
      right_sildbar_shop_car: "/static/images/right_sidebar/shop_car.png", //右侧导航栏 购物车 默认
      right_sildbar_shop_car_choose:
        "/static/images/right_sidebar/shop_car_choose.png", //右侧导航栏 购物车 选中
      right_sildbar_point: "/static/images/right_sidebar/point.png", //右侧导航栏 积分 默认
      right_sildbar_point_choose:
        "/static/images/right_sidebar/point_choose.png", //右侧导航栏 积分 选中
      right_sildbar_order: "/static/images/right_sidebar/order.png", //右侧导航栏 订单 默认
      right_sildbar_order_choose:
        "/static/images/right_sidebar/order_choose.png", //右侧导航栏 订单 选中
      right_sildbar_service: "/static/images/right_sidebar/service.png", //右侧导航栏 客服 默认
      right_sildbar_service_choose:
        "/static/images/right_sidebar/service_choose.png", //右侧导航栏 客服 选中
      right_sildbar_gongzhonghao:
        "/static/images/right_sidebar/gongzhonghao.png", //右侧导航栏 公众号 默认
      right_sildbar_gongzhonghao_choose:
        "/static/images/right_sidebar/gongzhonghao_choose.png", //右侧导航栏 公众号 选中
      right_sildbar_up: "/static/images/right_sidebar/up.png", //右侧导航栏 回到顶部 默认
      right_sildbar_up_choose: "/static/images/right_sidebar/up_choose.png" //右侧导航栏 回到顶部 选中
    };
    break;
  case "zk": //默认 常山众卡物流产业园文案
    companyConfigStr = {
      companyName: "众卡", //
      companyAllName: "常山众卡物流产业园投资有限公司", //公司全称
      englishName: "Changshan Zhongka Wuli Co., Ltd.", //英文名称
      copyRight: "浙ICP备2021014924号", //备案号
      logo_1: "/static/images/logo_01_zk.png", //登录页logo
      seagoorName: "众卡", //公司简称
      email: "vip@zkcyy.com", //邮件
      qiyukefu_url:
        "https://qiyukf.com/script/c92370d7893d49ebba71042ed5389f4a.js", //七鱼客服链接
      comp_url: "zkcyy", //域名
      kefu_name_1: "小众", //客服1名称
      kefu_name_2: "", //客服2名称
      kefu_wechat_1: "zkcyykefu", //客服1微信
      kefu_wechat_2: "", //客服2微信
      kefu_tel: "400-826-4949", //400电话
      skeleton_bg800: "bg800_zk.png", //骨架屏占位图
      skeleton_bg800_1: "/static/images/bg800_zk.png", //骨架屏占位图
      skeleton_bg1200: "/static/images/bg1200_zk.png", //骨架屏占位图
      mall_Img: "https://item.qn.zkcyy.com/fuli20200103.jpeg", //mall占位图
      preview_product_header: "/static/images/preview_product_header_zk.png", //预览头部图
      preview_product_footer: "/static/images/preview_product_footer_zk.png", //预览底部图
      /***
       **
       * 右侧导航栏
       **
       ***/
      right_sildbar_xiaochengxu: "/static/images/right_sidebar/xiaochengxu.png", //右侧导航栏 小程序 默认
      right_sildbar_xiaochengxu_choose:
        "/static/images/right_sidebar/xiaochengxu_choose.png", //右侧导航栏 小程序 选中
      right_sildbar_coupon: "/static/images/right_sidebar/coupon.png", //右侧导航栏 优惠券 默认
      right_sildbar_coupon_choose:
        "/static/images/right_sidebar/coupon_choose.png", //右侧导航栏 优惠券 选中
      right_sildbar_shop_car: "/static/images/right_sidebar/shop_car.png", //右侧导航栏 购物车 默认
      right_sildbar_shop_car_choose:
        "/static/images/right_sidebar/shop_car_choose.png", //右侧导航栏 购物车 选中
      right_sildbar_point: "/static/images/right_sidebar/point.png", //右侧导航栏 积分 默认
      right_sildbar_point_choose:
        "/static/images/right_sidebar/point_choose.png", //右侧导航栏 积分 选中
      right_sildbar_order: "/static/images/right_sidebar/order.png", //右侧导航栏 订单 默认
      right_sildbar_order_choose:
        "/static/images/right_sidebar/order_choose.png", //右侧导航栏 订单 选中
      right_sildbar_service: "/static/images/right_sidebar/service.png", //右侧导航栏 客服 默认
      right_sildbar_service_choose:
        "/static/images/right_sidebar/service_choose.png", //右侧导航栏 客服 选中
      right_sildbar_gongzhonghao:
        "/static/images/right_sidebar/gongzhonghao.png", //右侧导航栏 公众号 默认
      right_sildbar_gongzhonghao_choose:
        "/static/images/right_sidebar/gongzhonghao_choose.png", //右侧导航栏 公众号 选中
      right_sildbar_up: "/static/images/right_sidebar/up.png", //右侧导航栏 回到顶部 默认
      right_sildbar_up_choose: "/static/images/right_sidebar/up_choose.png" //右侧导航栏 回到顶部 选中
    };
    break;
  case "jingle": //默认 叮当惠卡有限公司文案
    companyConfigStr = {
      companyName: "叮叮当当", //
      companyAllName: "杭州叮叮当当科技有限公司", //公司全称
      englishName: "DingDingDangDang Technology Co., Ltd.", //英文名称
      copyRight: "浙ICP备2021018972号", //备案号
      logo_1: '/static/images/logo_01_jingle.png', //登录页logo
      seagoorName: "叮当惠卡", //公司简称
      email: "vip@ddingddang.com", //邮件
      qiyukefu_url:
        "https://qiyukf.com/script/c3d01d20c5b4c61be11b596b2e317a38.js", //七鱼客服链接
      comp_url: "ddingddang", //域名
      kefu_name_1: "小福", //客服1名称
      kefu_name_2: "小粒", //客服2名称
      kefu_wechat_1: "fuli3606", //客服1微信
      kefu_wechat_2: "fuli7151", //客服2微信
      kefu_tel: "400-969-0969", //400电话
      skeleton_bg800: "bg800_jingle.png", //骨架屏占位图
      skeleton_bg800_1: "/static/images/bg800_jingle.png", //骨架屏占位图
      skeleton_bg1200: "/static/images/bg1200_jingle.png", //骨架屏占位图
      mall_Img: "https://supplier.qn.seagoor.com/fuli20200103.jpeg", //mall占位图
      preview_product_header: "/static/images/preview_product_header_jingle.png", //预览头部图
      preview_product_footer: "/static/images/preview_product_footer_jingle.png", //预览底部图
      /***
       **
       * 右侧导航栏
       **
       ***/
      right_sildbar_xiaochengxu: "/static/images/right_sidebar/xiaochengxu.png", //右侧导航栏 小程序 默认
      right_sildbar_xiaochengxu_choose:
        "/static/images/right_sidebar/xiaochengxu_choose.png", //右侧导航栏 小程序 选中
      right_sildbar_coupon: "/static/images/right_sidebar/coupon.png", //右侧导航栏 优惠券 默认
      right_sildbar_coupon_choose:
        "/static/images/right_sidebar/coupon_choose.png", //右侧导航栏 优惠券 选中
      right_sildbar_shop_car: "/static/images/right_sidebar/shop_car.png", //右侧导航栏 购物车 默认
      right_sildbar_shop_car_choose:
        "/static/images/right_sidebar/shop_car_choose.png", //右侧导航栏 购物车 选中
      right_sildbar_point: "/static/images/right_sidebar/point.png", //右侧导航栏 积分 默认
      right_sildbar_point_choose:
        "/static/images/right_sidebar/point_choose.png", //右侧导航栏 积分 选中
      right_sildbar_order: "/static/images/right_sidebar/order.png", //右侧导航栏 订单 默认
      right_sildbar_order_choose:
        "/static/images/right_sidebar/order_choose.png", //右侧导航栏 订单 选中
      right_sildbar_service: "/static/images/right_sidebar/service.png", //右侧导航栏 客服 默认
      right_sildbar_service_choose:
        "/static/images/right_sidebar/service_choose.png", //右侧导航栏 客服 选中
      right_sildbar_gongzhonghao:
        "/static/images/right_sidebar/gongzhonghao.png", //右侧导航栏 公众号 默认
      right_sildbar_gongzhonghao_choose:
        "/static/images/right_sidebar/gongzhonghao_choose.png", //右侧导航栏 公众号 选中
      right_sildbar_up: "/static/images/right_sidebar/up.png", //右侧导航栏 回到顶部 默认
      right_sildbar_up_choose: "/static/images/right_sidebar/up_choose.png" //右侧导航栏 回到顶部 选中
    };
    break;
  default:
    //默认 福粒科技有限公司文案
    companyConfigStr = {
      companyName: "福粒", //
      companyAllName: "杭州福粒科技有限公司", //公司全称
      englishName: "Hangzhou Fuli Technology Co., Ltd.", //英文名称
      copyRight: "浙ICP备17011239号-1", //备案号
      logo_1: "/static/images/logo_01.png", //登录页logo
      seagoorName: "西狗国际", //公司简称
      email: "cs@seagoor.com", //邮件
      qiyukefu_url:
        "https://qiyukf.com/script/6e39dddabff63d902f55df3961c2793d.js", //七鱼客服链接
      comp_url: "lixiangshop", //域名
      kefu_name_1: "小福", //客服1名称
      kefu_name_2: "小粒", //客服2名称
      kefu_wechat_1: "fuli3606", //客服1微信
      kefu_wechat_2: "fuli7151", //客服2微信
      kefu_tel: "400-826-4949", //400电话
      skeleton_bg800: "bg800.png", //骨架屏占位图
      skeleton_bg800_1: "/static/images/bg800_1.png", //骨架屏占位图
      skeleton_bg1200: "/static/images/bg1200.png", //骨架屏占位图
      mall_Img: "https://supplier.qn.seagoor.com/fuli20200103.jpeg", //mall占位图
      preview_product_header: "/static/images/preview_product_header.png", //预览头部图
      preview_product_footer: "/static/images/preview_product_footer.png", //预览底部图
      /***
       **
       * 右侧导航栏
       **
       ***/
      right_sildbar_xiaochengxu: "/static/images/right_sidebar/xiaochengxu.png", //右侧导航栏 小程序 默认
      right_sildbar_xiaochengxu_choose:
        "/static/images/right_sidebar/xiaochengxu_choose.png", //右侧导航栏 小程序 选中
      right_sildbar_coupon: "/static/images/right_sidebar/coupon.png", //右侧导航栏 优惠券 默认
      right_sildbar_coupon_choose:
        "/static/images/right_sidebar/coupon_choose.png", //右侧导航栏 优惠券 选中
      right_sildbar_shop_car: "/static/images/right_sidebar/shop_car.png", //右侧导航栏 购物车 默认
      right_sildbar_shop_car_choose:
        "/static/images/right_sidebar/shop_car_choose.png", //右侧导航栏 购物车 选中
      right_sildbar_point: "/static/images/right_sidebar/point.png", //右侧导航栏 积分 默认
      right_sildbar_point_choose:
        "/static/images/right_sidebar/point_choose.png", //右侧导航栏 积分 选中
      right_sildbar_order: "/static/images/right_sidebar/order.png", //右侧导航栏 订单 默认
      right_sildbar_order_choose:
        "/static/images/right_sidebar/order_choose.png", //右侧导航栏 订单 选中
      right_sildbar_service: "/static/images/right_sidebar/service.png", //右侧导航栏 客服 默认
      right_sildbar_service_choose:
        "/static/images/right_sidebar/service_choose.png", //右侧导航栏 客服 选中
      right_sildbar_gongzhonghao:
        "/static/images/right_sidebar/gongzhonghao.png", //右侧导航栏 公众号 默认
      right_sildbar_gongzhonghao_choose:
        "/static/images/right_sidebar/gongzhonghao_choose.png", //右侧导航栏 公众号 选中
      right_sildbar_up: "/static/images/right_sidebar/up.png", //右侧导航栏 回到顶部 默认
      right_sildbar_up_choose: "/static/images/right_sidebar/up_choose.png", //右侧导航栏 回到顶部 选中
      privacyFlag:'fuli',//是否打开登录页的隐私协议
    };
}
// const companyConfig = {
//     companyConfigStr
// }
export default companyConfigStr;



// WEBPACK FOOTER //
// ./src/store/modules/manyCompany.js